export default "__VITE_ASSET__CyHDWflA__"